export default __webpack_public_path__ + "static/media/wallet.f9db4a53.svg";